import React from 'react';
import { IIconProps } from './utils';

export const MainIdeas = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.23633 13.5919H4.94331V16.0633H1.23633V13.5919ZM23.6018 4.3245L21.0069 6.91939L22.7368 8.64931L25.3317 6.05442L23.6018 4.3245ZM13.5929 1.23535H16.0642V4.94233H13.5929V1.23535ZM6.0554 4.3245L4.32548 6.05442L6.92036 8.64931L8.65029 6.91939L6.0554 4.3245ZM12.3573 27.1842C12.3573 27.9256 12.8515 28.4199 13.5929 28.4199H16.0642C16.8056 28.4199 17.2999 27.9256 17.2999 27.1842V25.9485H12.3573V27.1842ZM14.8286 7.41365C10.7509 7.41365 7.41463 10.7499 7.41463 14.8276C7.41463 17.5461 8.89742 20.0174 11.1216 21.253V23.4772C11.1216 24.2186 11.6159 24.7129 12.3573 24.7129H17.2999C18.0413 24.7129 18.5356 24.2186 18.5356 23.4772V21.253C20.7598 20.0174 22.2425 17.5461 22.2425 14.8276C22.2425 10.7499 18.9063 7.41365 14.8286 7.41365ZM16.0642 19.6467V21.0059H13.5929V19.6467C11.4923 19.1524 9.88595 17.1754 9.88595 14.8276C9.88595 12.1092 12.1101 9.88497 14.8286 9.88497C17.547 9.88497 19.7712 12.1092 19.7712 14.8276C19.7712 17.1754 18.1649 19.0289 16.0642 19.6467ZM24.7139 13.5919H28.4208V16.0633H24.7139V13.5919Z"
      fill={fill}
    />
  </svg>
);
